import { Component } from 'react';
import { STATUSES } from './keys';
import ManualClusterSelect from '../../../components/manualClusterModal';
import { withTranslation } from 'react-i18next';

class ExtraButtons extends Component {
    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btn-groups">
                        <button
                            className={`${(!this.props.view || this.props.view === 1) && 'active'}`}
                            onClick={() => this.props.onChange(1)}
                        >
                            {t('search.keywords.extraButtons.view1')}
                        </button>
                        <button
                            className={`${this.props.view === 2 && 'active'}`}
                            onClick={() => this.props.onChange(2)}
                        >
                            {t('search.keywords.extraButtons.view2')}
                        </button>
                    </div>
                    {this.props.view === 2 &&
                        STATUSES.map((item) => {
                            return (
                                <button
                                    className={`table-additional-view-btn ${
                                        this.props.status === item.value && 'active'
                                    }`}
                                    key={item.value}
                                    onClick={() => this.props.getData(item.value)}
                                    disabled={this.props.status === item.value}
                                >
                                    {t(`extraButtons.statuses.${item.value}`)}
                                </button>
                            );
                        })}
                </div>
                <ManualClusterSelect
                    current_url={this.props.current_url}
                    csrf_token={this.props.csrf_token}
                    selectedItems={this.props.selectedItems}
                    cluster_type="keyword"
                    header={t('search.keywords.extraButtons.addToKeywordList')}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
            </div>
        );
    }
}

export default withTranslation()(ExtraButtons);
